import { ETicketKnowMoreUrl, ETicketLotteryUrl, TicketingFormCategory } from "@simplyk/common";

export const TicketingFormCategoryFeatures = {
  [TicketingFormCategory.Custom]: {
    title: "ticketingForm.default.title.custom",
    defaultRateName: "ticketingForm.default.defaultRateName.custom" as const,
    eTicketSubtitle: "ticketingForm.default.eTicketSubtitle.custom",
    hasDate: true,
    hasLocation: true,
    hasReminder: true,
    hasTicketingSeats: true,
    hasETicket: true,
    displayLearnMoreOnETicket: true,
    eTicketKnowMoreLink: ETicketKnowMoreUrl,
  },
  [TicketingFormCategory.Event]: {
    title: "ticketingForm.default.title.event",
    defaultRateName: "ticketingForm.default.defaultRateName.event" as const,
    eTicketSubtitle: "ticketingForm.default.eTicketSubtitle.event",
    hasDate: true,
    hasLocation: true,
    hasReminder: true,
    hasTicketingSeats: true,
    hasETicket: true,
    displayLearnMoreOnETicket: true,
    eTicketKnowMoreLink: ETicketKnowMoreUrl,
  },
  [TicketingFormCategory.MembershipV2]: {
    title: "ticketingForm.default.title.membership",
    defaultRateName: "ticketingForm.default.defaultRateName.membershipV2" as const,
    eTicketSubtitle: "ticketingForm.default.eTicketSubtitle.membership",
    hasDate: false,
    hasLocation: false,
    hasReminder: false,
    hasTicketingSeats: false,
    hasETicket: true,
    displayLearnMoreOnETicket: false,
    eTicketKnowMoreLink: ETicketKnowMoreUrl,
  },
  [TicketingFormCategory.Lottery]: {
    title: "ticketingForm.default.title.lottery",
    defaultRateName: "ticketingForm.default.defaultRateName.lottery" as const,
    eTicketSubtitle: "ticketingForm.default.eTicketSubtitle.lottery",
    hasDate: true,
    hasLocation: false,
    hasReminder: false,
    hasTicketingSeats: true,
    hasETicket: true,
    displayLearnMoreOnETicket: true,
    eTicketKnowMoreLink: ETicketLotteryUrl,
  },
  [TicketingFormCategory.Sweepstakes]: {
    title: "ticketingForm.default.title.sweepstakes",
    defaultRateName: "ticketingForm.default.defaultRateName.sweepstakes" as const,
    eTicketSubtitle: "ticketingForm.default.eTicketSubtitle.sweepstakes",
    hasDate: true,
    hasLocation: false,
    hasReminder: false,
    hasTicketingSeats: true,
    hasETicket: true,
    displayLearnMoreOnETicket: true,
    eTicketKnowMoreLink: ETicketLotteryUrl,
  },
  [TicketingFormCategory.Shop]: {
    title: "ticketingForm.default.title.shop",
    defaultRateName: "ticketingForm.default.defaultRateName.shop" as const,
    eTicketSubtitle: "ticketingForm.default.eTicketSubtitle.shop",
    hasDate: false,
    hasLocation: false,
    hasReminder: false,
    hasTicketingSeats: false,
    hasETicket: false,
    displayLearnMoreOnETicket: true,
    eTicketKnowMoreLink: ETicketKnowMoreUrl,
  },
  [TicketingFormCategory.Auction]: {
    title: "ticketing.auctionTitlePlaceholder",
    defaultRateName: "ticketingForm.default.defaultRateName.auction" as const,
    eTicketSubtitle: "",
    hasDate: true,
    hasLocation: true,
    hasReminder: true,
    hasTicketingSeats: false,
    hasETicket: false,
    displayLearnMoreOnETicket: true,
    eTicketKnowMoreLink: ETicketKnowMoreUrl,
  },
};
